module.exports = __webpack_public_path__ + "img/webshop-trustmark.f571f777.png";